import { render, staticRenderFns } from "./StandardToolbar.vue?vue&type=template&id=a6550cfe&scoped=true&"
import script from "./StandardToolbar.vue?vue&type=script&lang=js&"
export * from "./StandardToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6550cfe",
  null
  
)

export default component.exports